import { ApiService } from "./api.service";
import { Router } from "@angular/router";

import { Injectable } from '@angular/core';
import { UserBalanceModel, PaymentModel} from "@bt/core";
//import { Observable, of } from 'rxjs';
import { IResponse } from "@bt/shared";

@Injectable()
export class FinanceService{

    constructor(private api: ApiService,
                private router: Router){}


    public GetUserBalance(): Promise<IResponse<UserBalanceModel>>{
        return this.api.get<UserBalanceModel>("api/finance/getuserbalance").toPromise();
    }

    public GetUserPayments(): Promise<IResponse<PaymentModel[]>>{
        return this.api.get<PaymentModel[]>("api/finance/getuserpayment").toPromise();
    }

    public AddNewUserPayment(newPayment: PaymentModel):Promise<IResponse<boolean>>{
        return this.api.post<boolean>("api/finance/addnewuserpayment",newPayment).toPromise();
    }

    public CanceledPayment(canceledPaymentId: number):Promise<IResponse<boolean>>{
        return this.api.get<boolean>("api/finance/cancaleduserpayment/"+canceledPaymentId).toPromise();
    }

    public ApprovedPayment(approvedPaymentId: number):Promise<IResponse<boolean>>{
        return this.api.get<boolean>("api/finance/approveduserpayment/"+approvedPaymentId).toPromise();
    }

    
}


// WEBPACK FOOTER //
// ./src/app/core/services/finance.service.ts